(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[915],{

/***/ 57952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[doctorId]",
      function () {
        return __webpack_require__(24457);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fc14f8a-0"
})(_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "1px" : _height, _color = param.color, color = _color === void 0 ? "#efefef" : _color, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _margin = param.margin, margin = _margin === void 0 ? "0" : _margin;
    return "\n    display: ".concat(isVisible ? "block" : "none", ";\n    height: ").concat(height, ";\n    background-color: ").concat(color, ";\n    margin: ").concat(margin, ";\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5622395-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5622395-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5622395-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5622395-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-b5622395-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    background: ").concat(theme.color.primary600, ";\n    color: ").concat(theme.color.white, ";\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-b5622395-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5622395-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-b5622395-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-b5622395-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});


/***/ }),

/***/ 40795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ArrowsButtonRightMin = function(param) {
    var _color = param.color, color = _color === void 0 ? "#8D9297" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.2998 11.625L8.72168 8.28125L5.2998 4.95312L6.2373 4L10.6436 8.28125L6.2373 12.5781L5.2998 11.625Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonRightMin);


/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var ArrowsButtonDownMin = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray400 */ .Z.color.gray400 : _color, _size = param.size, size = _size === void 0 ? 16 : _size, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonDownMin);


/***/ }),

/***/ 44387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var FullBooked = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "\\bFullBooked_48",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle 1",
                    x: "2",
                    y: "6",
                    width: "44",
                    height: "39",
                    rx: "4",
                    fill: "#EDEFF0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Rectangle 2",
                    d: "M2 10C2 7.79086 3.79086 6 6 6H42C44.2091 6 46 7.79086 46 10V17H2V10Z",
                    fill: "#C6CACE"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle 3",
                    x: "12",
                    y: "1",
                    width: "4",
                    height: "10",
                    rx: "2",
                    fill: "#C6CACE"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle 4",
                    x: "32",
                    y: "1",
                    width: "4",
                    height: "10",
                    rx: "2",
                    fill: "#C6CACE"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Vector",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M30.5097 24.4903C31.1634 25.1439 31.1634 26.2038 30.5097 26.8574L19.8574 37.5097C19.2038 38.1634 18.1439 38.1634 17.4903 37.5097C16.8366 36.8561 16.8366 35.7962 17.4903 35.1426L28.1426 24.4903C28.7962 23.8366 29.8561 23.8366 30.5097 24.4903Z",
                            fill: "#C6CACE"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M30.5097 37.5097C29.8561 38.1634 28.7962 38.1634 28.1426 37.5097L17.4903 26.8574C16.8366 26.2038 16.8366 25.1439 17.4903 24.4903C18.1439 23.8366 19.2038 23.8366 19.8574 24.4903L30.5097 35.1426C31.1634 35.7962 31.1634 36.8561 30.5097 37.5097Z",
                            fill: "#C6CACE"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullBooked);


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload;
    var logger = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var child = react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        onClick: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            logger.log({
                eventName: eventName,
                payload: payload
            });
            if (child.props && typeof child.props["onClick"] === "function") {
                var _props;
                return (_props = child.props)["onClick"].apply(_props, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args));
            }
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 46213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89961);
/* harmony import */ var _hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13041);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var KakaoMap = function(_param) {
    var latitude = _param.latitude, longitude = _param.longitude, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "latitude",
        "longitude"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,_hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        target: loaderElement
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting)) return;
        var mapScript = document.createElement("script");
        mapScript.async = true;
        var _NEXT_PUBLIC_KAKAO_JS_KEY;
        mapScript.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=".concat((_NEXT_PUBLIC_KAKAO_JS_KEY = "b921b0231b604bf1aea6460c3d26cb57") !== null && _NEXT_PUBLIC_KAKAO_JS_KEY !== void 0 ? _NEXT_PUBLIC_KAKAO_JS_KEY : "", "&autoload=false");
        document.head.appendChild(mapScript);
        var onLoadKakaoMap = function() {
            window.kakao.maps.load(function() {
                var container = document.getElementById("map");
                if (!container) return;
                var options = {
                    center: new window.kakao.maps.LatLng(latitude, longitude),
                    draggable: false
                };
                var map = new window.kakao.maps.Map(container, options);
                var markerPosition = new window.kakao.maps.LatLng(latitude, longitude);
                var marker = new window.kakao.maps.Marker({
                    position: markerPosition
                });
                marker.setMap(map);
            });
        };
        mapScript.addEventListener("load", onLoadKakaoMap);
        return function() {
            return mapScript.removeEventListener("load", onLoadKakaoMap);
        };
    }, [
        entry,
        latitude,
        longitude
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MapWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: function(ref) {
            return setLoaderElement(ref);
        }
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Map, {
            id: "map",
            onScroll: undefined
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (KakaoMap);
var MapWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a92e3983-0"
})(_templateObject());
var Map = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a92e3983-1"
})(_templateObject1());


/***/ }),

/***/ 57823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 8px 0 6px;\n  z-index: 1;\n  white-space: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px 8px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var DNSlideTabItem = function(_param) {
    var label = _param.label, isActive = _param.isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: isActive ? "DNSlideTabItem_selected" : "DNSlideTabItem",
        isActive: isActive,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
            isActive: isActive,
            children: label
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTabItem);
var StyledTabItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-b5de5b68-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    border-bottom: 2px solid ".concat(isActive ? "".concat(theme.color.gray800) : "transparent", "\n  ");
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-b5de5b68-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    ".concat(isActive ? theme.typography.UI15SB : theme.typography.UI15M, ";\n    color: ").concat(isActive ? theme.color.gray800 : theme.color.gray400, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57823);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76666);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  padding: 0 24px;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DNSlideTab = function(_param) {
    var value = _param.value, _group = _param.group, group = _group === void 0 ? false : _group, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "value",
        "group",
        "children"
    ]);
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value) return;
        if (!scrollRef.current) return;
        var children = Array.from(scrollRef.current.children);
        children.forEach(function(child) {
            if (child.classList.contains("DNSlideTabItem_selected")) {
                var ref = child.getBoundingClientRect(), left = ref.left, width = ref.width;
                var innerWidth = window.innerWidth;
                if (left + width / 2 !== innerWidth / 2) {
                    var ref1, ref2;
                    (ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                        top: 0,
                        left: ((ref2 = scrollRef.current) === null || ref2 === void 0 ? void 0 : ref2.scrollLeft) + (left - innerWidth / 2 + width / 2),
                        behavior: "smooth"
                    });
                }
            }
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_5__.cn)([
            "relative",
            props.className
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                ref: scrollRef,
                group: group,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BorderBottom, {})
        ]
    });
};
DNSlideTab.Item = _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTab);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bf37eb69-0"
})(_templateObject(), function(param) {
    var group = param.group;
    return "\n    ".concat(group ? "\n          button {\n            flex: 1;\n            span {\n              width: 100%;\n            }\n          }" : "", ";\n  ");
});
var BorderBottom = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bf37eb69-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});


/***/ }),

/***/ 24457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _doctorId_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/LoginModal/index.tsx + 5 modules
var LoginModal = __webpack_require__(4329);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ReportSelectModal/index.tsx
var ReportSelectModal = __webpack_require__(28879);
// EXTERNAL MODULE: ./src/components/molecules/Overlay/index.tsx + 1 modules
var Overlay = __webpack_require__(78952);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 4 modules
var StickyAppHeader = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorDetailSkeleton/DoctorDetailSkeleton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 0 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  margin: 8px 0px 20px 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 240px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var DoctorDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        style: {
                            justifyContent: "center",
                            marginBottom: 24
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                            src: "/images/doctor/doctor_default_profile.png",
                            alt: "default_image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        style: {
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    style: {
                                        width: "20%",
                                        height: 18,
                                        marginBottom: 8
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    style: {
                                        width: "30%",
                                        height: 30,
                                        marginBottom: 8
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                    style: {
                                        marginBottom: 16
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            style: {
                                                width: "20%",
                                                height: 18,
                                                marginRight: 8
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            style: {
                                                width: "20%",
                                                height: 18,
                                                marginRight: 8
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            style: {
                                                width: "20%",
                                                height: 18,
                                                marginRight: 8
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        style: {
                            marginBottom: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "15%",
                                    height: 20,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "15%",
                                    height: 20,
                                    marginRight: 8
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "10%",
                                    height: 20,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "30%",
                                    height: 20,
                                    marginRight: 8
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "18%",
                            height: 30,
                            marginRight: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "25%",
                            height: 30,
                            marginRight: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "20%",
                            height: 30,
                            marginRight: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "25%",
                            height: 30,
                            marginRight: 10
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "20%",
                            height: 30,
                            marginBottom: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "80%",
                            height: 20,
                            marginBottom: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "80%",
                            height: 20,
                            marginBottom: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "80%",
                            height: 20,
                            marginBottom: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "80%",
                            height: 20,
                            marginBottom: 10
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "20%",
                            height: 30,
                            marginBottom: 10
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "100%",
                            height: 300,
                            marginBottom: 10
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DoctorDetailSkeleton_DoctorDetailSkeleton = (DoctorDetailSkeleton);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d2fd60-0"
})(_templateObject());
var Card = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d2fd60-1"
})(_templateObject1(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var Col = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d2fd60-2"
})(_templateObject2());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d2fd60-3"
})(_templateObject3());
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22d2fd60-4"
})(_templateObject4(), theme/* default.color.gray40 */.Z.color.gray40);
var Tabs = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-22d2fd60-5"
})(_templateObject5());
var Section = (0,styled_components_browser_esm/* default */.ZP)(Col).withConfig({
    componentId: "sc-22d2fd60-6"
})(_templateObject6());
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-22d2fd60-7"
})(_templateObject7());

// EXTERNAL MODULE: ./src/components/atom/Divider.tsx
var atom_Divider = __webpack_require__(47064);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DoctorProfile.tsx

function DoctorProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n"
    ]);
    DoctorProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 24px 0;\n"
    ]);
    DoctorProfile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  align-self: stretch;\n"
    ]);
    DoctorProfile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorProfile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorProfile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n      opacity: 0;\n  }\n\n  100% { opacity: 1}\n"
    ]);
    DoctorProfile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DoctorProfile_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 240px;\n  border-radius: 40px;\n  background-position: center;\n  background-size: contain;\n\n  animation: 0.5s ",
        " ease-in-out;\n"
    ]);
    DoctorProfile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var DoctorProfile = function(param) {
    var viewModel = param.viewModel;
    if (!viewModel.doctorDetail) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorProfile_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfileImage, {
                style: {
                    backgroundImage: 'url("'.concat(viewModel.doctorDetail.doctor.profileImageUrl, '")')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorDescription, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorAndHospitalName, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalName, {
                            children: viewModel.doctorDetail.hospital.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                    children: viewModel.getDoctorDisplayName(viewModel.doctorDetail.doctor.name, viewModel.doctorDetail.doctor.medicineType)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                    className: (0,style.cn)([
                                        "cursor-pointer",
                                        viewModel.isFamilyDoctor ? "text-red-600" : "text-gray-100"
                                    ]),
                                    name: "favorite",
                                    filled: true,
                                    size: 24,
                                    onClick: function() {
                                        viewModel.handleUpdateFamilyDoctor([
                                            viewModel.doctorDetail.doctor.id
                                        ]);
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var DoctorSummary_DoctorProfile = (DoctorProfile);
var DoctorProfile_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-0"
})(DoctorProfile_templateObject());
var DoctorDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-1"
})(DoctorProfile_templateObject1());
var DoctorAndHospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-2"
})(DoctorProfile_templateObject2());
var HospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-3"
})(DoctorProfile_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var DoctorName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-4"
})(DoctorProfile_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var animationKeyFrames = (0,styled_components_browser_esm/* keyframes */.F4)(DoctorProfile_templateObject5());
var DoctorProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674e55c-5"
})(DoctorProfile_templateObject6(), animationKeyFrames);

;// CONCATENATED MODULE: ./src/components/atom/icon/doctor/Star.tsx

var Star = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.99994 12.5996L11.4583 14.6913C12.0916 15.0746 12.8666 14.508 12.6999 13.7913L11.7833 9.85797L14.8416 7.20798C15.3999 6.72464 15.0999 5.80798 14.3666 5.74964L10.3416 5.40798L8.7666 1.69131C8.48327 1.01631 7.5166 1.01631 7.23327 1.69131L5.65827 5.39964L1.63327 5.74131C0.899939 5.79964 0.599938 6.71631 1.15827 7.19964L4.2166 9.84964L3.29994 13.783C3.13327 14.4996 3.90827 15.0663 4.5416 14.683L7.99994 12.5996Z",
            fill: "#FCC419"
        })
    });
};
/* harmony default export */ var doctor_Star = (Star);

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DoctorReviewAndDepartments.tsx

function DoctorReviewAndDepartments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  display: block;\n"
    ]);
    DoctorReviewAndDepartments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0px 4px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n"
    ]);
    DoctorReviewAndDepartments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n"
    ]);
    DoctorReviewAndDepartments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    DoctorReviewAndDepartments_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 12px;\n  background-color: ",
        ";\n  margin: 0 4px;\n"
    ]);
    DoctorReviewAndDepartments_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    DoctorReviewAndDepartments_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorReviewAndDepartments_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DoctorReviewAndDepartments_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    DoctorReviewAndDepartments_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 20px;\n  padding: 0px 4px;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n  border-radius: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var DoctorReviewAndDepartments = function(param) {
    var doctorDetailViewModel = param.doctorDetailViewModel, doctorReviewsViewModel = param.doctorReviewsViewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReviewAndDepartments_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OperationTimeToggleRow, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorStatusCol, {
                children: [
                    doctorReviewsViewModel.hasReview() && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorStatusRow, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(doctor_Star, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AverageRating, {
                                    children: doctorDetailViewModel.getDisplayAverageRating()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLine, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewCount, {
                                    onClick: doctorDetailViewModel.goToReview,
                                    children: [
                                        (0,format/* formatPriceComma */.dM)(doctorReviewsViewModel.totalCount),
                                        "개 후기",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                            name: "chevron_right",
                                            size: 16,
                                            color: theme/* default.color.gray400 */.Z.color.gray400
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                        children: doctorDetailViewModel.doctorDetail.doctor.departments.map(function(department) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag, {
                                isProfessional: department.isProfessional,
                                children: [
                                    department.name,
                                    department.isProfessional ? "전문의" : ""
                                ]
                            }, "department-".concat(department.id));
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DoctorSummary_DoctorReviewAndDepartments = (DoctorReviewAndDepartments);
var DoctorReviewAndDepartments_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-0"
})(DoctorReviewAndDepartments_templateObject());
var OperationTimeToggleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-1"
})(DoctorReviewAndDepartments_templateObject1());
var DoctorStatusRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-2"
})(DoctorReviewAndDepartments_templateObject2());
var RatingRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-3"
})(DoctorReviewAndDepartments_templateObject3());
var BorderLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-4"
})(DoctorReviewAndDepartments_templateObject4(), theme/* default.color.gray100 */.Z.color.gray100);
var ReviewCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-5"
})(DoctorReviewAndDepartments_templateObject5(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI14M, ";\n    color: ").concat(_$theme.color.gray400, ";\n  ");
});
var AverageRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-6"
})(DoctorReviewAndDepartments_templateObject6(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI14M, ";\n    color: ").concat(_$theme.color.gray700, ";\n  ");
});
var DoctorStatusCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-7"
})(DoctorReviewAndDepartments_templateObject7());
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-8"
})(_templateObject8());
var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfd471e5-9"
})(_templateObject9(), function(param) {
    var _$theme = param.theme, isProfessional = param.isProfessional;
    return "\n    ".concat(_$theme.typography.UI12M, ";\n    background: ").concat(isProfessional ? _$theme.color.blue100 : _$theme.color.gray30, ";\n    color: ").concat(isProfessional ? _$theme.color.blue600 : _$theme.color.gray300, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/icon/Arrow/ArrowsButtonRightMin.tsx
var ArrowsButtonRightMin = __webpack_require__(40795);
// EXTERNAL MODULE: ./src/types/doctor.ts
var doctor = __webpack_require__(79051);
// EXTERNAL MODULE: ./src/components/molecules/BottomSheet/index.tsx + 5 modules
var BottomSheet = __webpack_require__(39535);
// EXTERNAL MODULE: ./src/components/atom/icon/FullBooked.tsx
var FullBooked = __webpack_require__(44387);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DiagnosisEmptySlot.tsx

function DiagnosisEmptySlot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n  gap: 20px;\n  align-items: center;\n"
    ]);
    DiagnosisEmptySlot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DiagnosisEmptySlot_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    DiagnosisEmptySlot_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DiagnosisEmptySlot = function(param) {
    var bookingScheduleStatus = param.bookingScheduleStatus;
    switch(bookingScheduleStatus){
        case doctor/* BookingScheduleStatus.FullyBooked */.Uc.FullyBooked:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiagnosisEmptySlot_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullBooked/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contents, {
                        children: [
                            "예약이 꽉 찼어요",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "다른 날짜를 선택해주세요"
                            })
                        ]
                    })
                ]
            });
        case doctor/* BookingScheduleStatus.Holiday */.Uc.Holiday:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiagnosisEmptySlot_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullBooked/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contents, {
                        children: [
                            "비대면 진료 쉬는 날이에요",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "다른 날짜를 선택해주세요."
                            })
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
/* harmony default export */ var DoctorSummary_DiagnosisEmptySlot = (DiagnosisEmptySlot);
var DiagnosisEmptySlot_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-daaf8a12-0"
})(DiagnosisEmptySlot_templateObject());
var Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-daaf8a12-1"
})(DiagnosisEmptySlot_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.gray700, ";\n\n    span {\n      margin-top: 4px;\n      ").concat(theme.typography.UI15R, ";\n      color: ").concat(theme.color.gray400, ";\n    }\n  ");
});

// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DiagnosisSlotBottomSheet.tsx

function DiagnosisSlotBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px 0;\n  ",
        "\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 4px;\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n\n  ",
        ";\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  padding: 20px 0 24px 0;\n  height: ",
        "px;\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 3fr));\n  gap: 8px;\n  overflow: scroll;\n  align-content: flex-start;\n\n  ",
        "\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 7px 28px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 48px;\n\n  ",
        "\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DiagnosisSlotBottomSheet_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 20px;\n  width: 100%;\n  right: 0;\n  ",
        "\n"
    ]);
    DiagnosisSlotBottomSheet_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var TITLE_HEIGHT = 30;
var DAYS_WRAPPER_HEIGHT = 86;
var TIME_SLOT_WRAPPER_MARGIN_BOTTOM = 40;
var TIME_SLOT_TOP_GRADIENT_SCROLL_TOP = 24;
var DiagnosisSlotBottomSheet = function(param) {
    var isOpened = param.isOpened, bookingSchedules = param.bookingSchedules, selectedDiagnosisSlot = param.selectedDiagnosisSlot, onClose = param.onClose, onChangeDiagnosisSlot = param.onChangeDiagnosisSlot, requestTreatmentWithSlot = param.requestTreatmentWithSlot;
    var timeSlotWrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isTimeSlotTopGradient = ref[0], setIsTimeSlotTopGradient = ref[1];
    var ref1 = (0,react.useState)(true), isTimeSlotBottomGradient = ref1[0], setIsTimeSlotBottomGradient = ref1[1];
    var ref2;
    var selectedSlot = (ref2 = bookingSchedules.find(function(schedule) {
        return schedule.targetDate === (selectedDiagnosisSlot === null || selectedDiagnosisSlot === void 0 ? void 0 : selectedDiagnosisSlot.targetDate);
    })) !== null && ref2 !== void 0 ? ref2 : bookingSchedules[0];
    var setTimeSlotTopGradient = (0,react.useCallback)(function() {
        if (timeSlotWrapperRef === null || timeSlotWrapperRef === void 0 ? void 0 : timeSlotWrapperRef.current) {
            var ref;
            if (((ref = timeSlotWrapperRef.current) === null || ref === void 0 ? void 0 : ref.scrollTop) > TIME_SLOT_TOP_GRADIENT_SCROLL_TOP) {
                return setIsTimeSlotTopGradient(true);
            }
            return setIsTimeSlotTopGradient(false);
        }
    }, []);
    var setTimeSlotBottomGradient = (0,react.useCallback)(function() {
        if (timeSlotWrapperRef === null || timeSlotWrapperRef === void 0 ? void 0 : timeSlotWrapperRef.current) {
            if (timeSlotWrapperRef.current.scrollTop + timeSlotWrapperRef.current.offsetHeight !== timeSlotWrapperRef.current.scrollHeight) {
                return setIsTimeSlotBottomGradient(true);
            }
            return setIsTimeSlotBottomGradient(false);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!isOpened) return;
        if (!timeSlotWrapperRef.current) return;
        var ref = timeSlotWrapperRef.current;
        ref.addEventListener("scroll", function() {
            setTimeSlotTopGradient();
            setTimeSlotBottomGradient();
        });
        return function() {
            if (!timeSlotWrapperRef) return;
            ref.removeEventListener("scroll", function() {
                setTimeSlotTopGradient();
                setTimeSlotBottomGradient();
            });
        };
    }, [
        isOpened,
        setTimeSlotTopGradient,
        setTimeSlotBottomGradient
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheet/* default */.ZP, {
        index: 10,
        isOpened: isOpened,
        onClickOverlay: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisSlotBottomSheet_Wrapper, {
                isBookable: selectedSlot.status === doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiagnosisSlotBottomSheet_Contents, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "언제 진료받으시나요?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DayWrapper, {
                            children: bookingSchedules.map(function(bookingSchedule) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DaySelect, {
                                    selected: selectedSlot.targetDate === bookingSchedule.targetDate,
                                    onClick: function() {
                                        onChangeDiagnosisSlot({
                                            targetDate: bookingSchedule.targetDate,
                                            bookingStatus: bookingSchedule.status
                                        });
                                    },
                                    children: bookingSchedule.displayName
                                }, bookingSchedule.targetDate);
                            })
                        }),
                        selectedSlot.status !== doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DiagnosisEmptySlot, {
                            bookingScheduleStatus: selectedSlot.status
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeSlotContainer, {
                            children: [
                                isTimeSlotTopGradient && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {
                                    top: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSlotWrapper, {
                                    ref: timeSlotWrapperRef,
                                    children: selectedSlot.schedules.map(function(schedule) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TimeSlot, {
                                            isSelected: (selectedDiagnosisSlot === null || selectedDiagnosisSlot === void 0 ? void 0 : selectedDiagnosisSlot.startTimeSlotValue) === schedule.startTimeSlot.value,
                                            disabled: schedule.bookingStatus !== doctor/* BookingScheduleTypeVo.Bookable */.Ts.Bookable,
                                            onClick: function() {
                                                return onChangeDiagnosisSlot({
                                                    targetDate: selectedSlot.targetDate,
                                                    startTimeSlotValue: schedule.startTimeSlot.value,
                                                    endTimeSlotValue: schedule.endTimeSlot.value,
                                                    bookingStatus: schedule.bookingStatus
                                                });
                                            },
                                            children: [
                                                schedule.startTimeSlot.fromDisplayTime,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "~",
                                                        schedule.endTimeSlot.toDisplayTime
                                                    ]
                                                })
                                            ]
                                        }, schedule.startTimeSlot.value);
                                    })
                                }),
                                isTimeSlotBottomGradient && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {
                                    bottom: true
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    size: "xl",
                    className: "w-full",
                    disabled: (selectedDiagnosisSlot === null || selectedDiagnosisSlot === void 0 ? void 0 : selectedDiagnosisSlot.startTimeSlotValue) === undefined,
                    onClick: requestTreatmentWithSlot,
                    children: "진료 신청서 작성하기"
                })
            })
        ]
    });
};
/* harmony default export */ var DoctorSummary_DiagnosisSlotBottomSheet = (DiagnosisSlotBottomSheet);
var DiagnosisSlotBottomSheet_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-0"
})(DiagnosisSlotBottomSheet_templateObject(), function(param) {
    var theme = param.theme, isBookable = param.isBookable;
    return "\n    height: calc(100vh * ".concat(isBookable ? 0.8 : 0.5, " - ").concat(theme.size.stickyButton.height, "px);\n  ");
});
var DiagnosisSlotBottomSheet_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-1"
})(DiagnosisSlotBottomSheet_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-2"
})(DiagnosisSlotBottomSheet_templateObject2(), TITLE_HEIGHT, function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var DayWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-3"
})(DiagnosisSlotBottomSheet_templateObject3(), DAYS_WRAPPER_HEIGHT);
var DaySelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-4"
})(DiagnosisSlotBottomSheet_templateObject4(), function(param) {
    var theme = param.theme, selected = param.selected;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    border-radius: 8px;\n    padding: 10px 20px;\n    color: ").concat(selected ? theme.color.primary700 : theme.color.gray600, ";\n    border: 1px solid ").concat(selected ? theme.color.primary600 : theme.color.gray100, ";\n  ");
});
var TimeSlotContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-5"
})(DiagnosisSlotBottomSheet_templateObject5());
var TimeSlotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-6"
})(DiagnosisSlotBottomSheet_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    height: calc(100vh * 0.8 - ".concat(TITLE_HEIGHT + DAYS_WRAPPER_HEIGHT + TIME_SLOT_WRAPPER_MARGIN_BOTTOM + theme.size.stickyButton.height, "px);\n  ");
});
var TimeSlot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-1db0cc04-7"
})(DiagnosisSlotBottomSheet_templateObject7(), function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(isSelected ? theme.color.primary700 : theme.color.gray600, ";\n    border: 1px solid ").concat(isSelected ? theme.color.primary600 : theme.color.gray100, ";\n\n    span {\n      ").concat(theme.typography.UI12M, ";\n      color: ").concat(theme.color.gray300, ";\n      margin-top: -4px;\n    }\n    \n    &:disabled {\n      ").concat(theme.typography.UI14M, ";\n      color: ").concat(theme.color.gray300, ";\n      border: 1px solid ").concat(theme.color.gray40, ";\n      background: ").concat(theme.color.gray40, ";\n\n      span {\n        color: ").concat(theme.color.gray300, ";\n      }\n    }\n  ");
});
var Gradient = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1db0cc04-8"
})(DiagnosisSlotBottomSheet_templateObject8(), function(param) {
    var top = param.top, bottom = param.bottom;
    return "\n    ".concat(top && "\n        top: -1px;\n        background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%); \n      ", ";\n    ").concat(bottom && "\n        bottom: -1px;\n        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n      ", "\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DoctorDiagnosisSchedules.tsx

function DoctorDiagnosisSchedules_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DoctorDiagnosisSchedules_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorDiagnosisSchedules_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 13px 16px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 24px;\n\n  ",
        ";\n"
    ]);
    DoctorDiagnosisSchedules_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorDiagnosisSchedules_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  ",
        "\n  ",
        "\n    span {\n    ",
        "\n    color: ",
        "\n  }\n"
    ]);
    DoctorDiagnosisSchedules_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorDiagnosisSchedules_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 12px;\n  gap: 8px;\n  overflow: scroll;\n  padding: 0 24px;\n"
    ]);
    DoctorDiagnosisSchedules_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorDiagnosisSchedules_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 12px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 40px;\n\n  ",
        ";\n"
    ]);
    DoctorDiagnosisSchedules_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var DoctorDiagnosisSchedules = function(param) {
    var doctorDetail = param.doctorDetail, isOpenedDiagnosisSlotBottomSheet = param.isOpenedDiagnosisSlotBottomSheet, selectedDiagnosisSlot = param.selectedDiagnosisSlot, onClickDiagnosisSlotInSummary = param.onClickDiagnosisSlotInSummary, onClickDiagnosisSlotSelectBox = param.onClickDiagnosisSlotSelectBox, onChangeDiagnosisSlotBottomSheet = param.onChangeDiagnosisSlotBottomSheet, onChangeDiagnosisSlot = param.onChangeDiagnosisSlot, requestTreatmentWithSlot = param.requestTreatmentWithSlot;
    var todaySchedules = doctorDetail.diagnosisBookingSchedules[0];
    var isTodayBookable = todaySchedules.status === doctor/* BookingScheduleStatus.Bookable */.Uc.Bookable;
    var availableSchedules = isTodayBookable ? doctorDetail.diagnosisBookingSchedules[0] : doctorDetail.diagnosisBookingSchedules[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDiagnosisSchedules_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectBox, {
                onClick: onClickDiagnosisSlotSelectBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiagnosisInfo, {
                        isTodayBookable: isTodayBookable,
                        children: [
                            isTodayBookable ? "오늘" : "내일",
                            " 예약",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isTodayBookable ? "".concat(doctorDetail.bookingInfo.todayKickoffTime, " ~\n              ").concat(doctorDetail.bookingInfo.todayCutoffTime) : "".concat(doctorDetail.bookingInfo.tomorrowKickoffTime, " ~\n              ").concat(doctorDetail.bookingInfo.tomorrowCutoffTime)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsButtonRightMin/* default */.Z, {
                        color: theme/* default.color.gray600 */.Z.color.gray600
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlotWrapper, {
                children: availableSchedules.schedules.map(function(schedule) {
                    return schedule.bookingStatus === doctor/* BookingScheduleTypeVo.Bookable */.Ts.Bookable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slot, {
                        onClick: function() {
                            return onClickDiagnosisSlotInSummary({
                                targetDate: availableSchedules.targetDate,
                                startTimeSlotValue: schedule.startTimeSlot.value,
                                endTimeSlotValue: schedule.endTimeSlot.value,
                                bookingStatus: schedule.bookingStatus
                            });
                        },
                        children: schedule.startTimeSlot.displayTime
                    }, schedule.startTimeSlot.value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DiagnosisSlotBottomSheet, {
                isOpened: isOpenedDiagnosisSlotBottomSheet,
                onClose: onChangeDiagnosisSlotBottomSheet,
                bookingSchedules: doctorDetail.diagnosisBookingSchedules,
                selectedDiagnosisSlot: selectedDiagnosisSlot,
                onChangeDiagnosisSlot: onChangeDiagnosisSlot,
                requestTreatmentWithSlot: requestTreatmentWithSlot
            })
        ]
    });
};
/* harmony default export */ var DoctorSummary_DoctorDiagnosisSchedules = (DoctorDiagnosisSchedules);
var DoctorDiagnosisSchedules_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c595253-0"
})(DoctorDiagnosisSchedules_templateObject());
var SelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c595253-1"
})(DoctorDiagnosisSchedules_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray100, ";\n    \n    &:hover {\n      cursor: pointer;\n    }\n    // 색상 확인 필요\n    &:active {\n      background: ").concat(theme.color.gray10, ";\n    }\n  ");
});
var DiagnosisInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c595253-2"
})(DoctorDiagnosisSchedules_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15SB;
}, function(param) {
    var theme = param.theme, isTodayBookable = param.isTodayBookable;
    switch(isTodayBookable){
        case true:
            {
                return "\n          color: ".concat(theme.color.green700, ";\n        ");
            }
        default:
            {
                return "\n          color: ".concat(theme.color.primary600, ";\n        ");
            }
    }
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray200;
});
var SlotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c595253-3"
})(DoctorDiagnosisSchedules_templateObject3());
var Slot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c595253-4"
})(DoctorDiagnosisSchedules_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray30, ";\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    // 색상 확인 필요\n    &:active {\n      background: ").concat(theme.color.gray20, ";\n    }\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorSummary/DoctorSummary.tsx

function DoctorSummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-bottom: 28px;\n  flex-direction: column;\n  gap: 12px;\n  align-self: stretch;\n"
    ]);
    DoctorSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorSummary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: calc(100% - 48px);\n  align-self: center;\n  margin: 12px 0;\n"
    ]);
    DoctorSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorSummary_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n"
    ]);
    DoctorSummary_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var DoctorSummary = function(param) {
    var doctorDetailViewModel = param.doctorDetailViewModel, doctorReviewsViewModel = param.doctorReviewsViewModel;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorSummary_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DoctorProfile, {
                viewModel: doctorDetailViewModel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewAndDepartments, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DoctorReviewAndDepartments, {
                    doctorDetailViewModel: doctorDetailViewModel,
                    doctorReviewsViewModel: doctorReviewsViewModel
                })
            }),
            doctorDetailViewModel.isBookableFromBookingAvailability((ref = doctorDetailViewModel.doctorDetail) === null || ref === void 0 ? void 0 : (ref1 = ref.bookingInfo) === null || ref1 === void 0 ? void 0 : ref1.bookingAvailability) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                    doctorDetailViewModel.doctorDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DoctorDiagnosisSchedules, {
                        doctorDetail: doctorDetailViewModel.doctorDetail,
                        onClickDiagnosisSlotInSummary: doctorDetailViewModel.onClickDiagnosisSlotInSummary,
                        onClickDiagnosisSlotSelectBox: doctorDetailViewModel.onClickDiagnosisSlotSelectBox,
                        isOpenedDiagnosisSlotBottomSheet: doctorDetailViewModel.isOpenedDiagnosisSlotBottomSheet,
                        onChangeDiagnosisSlotBottomSheet: doctorDetailViewModel.onChangeDiagnosisSlotBottomSheet,
                        selectedDiagnosisSlot: doctorDetailViewModel.selectedDiagnosisSlot,
                        onChangeDiagnosisSlot: doctorDetailViewModel.onChangeDiagnosisSlot,
                        requestTreatmentWithSlot: doctorDetailViewModel.requestTreatmentWithSlot
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DoctorSummary_DoctorSummary = (DoctorSummary);
var DoctorSummary_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90905ca8-0"
})(DoctorSummary_templateObject());
var StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(atom_Divider/* default */.Z).withConfig({
    componentId: "sc-90905ca8-1"
})(DoctorSummary_templateObject1());
var ReviewAndDepartments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90905ca8-2"
})(DoctorSummary_templateObject2());

// EXTERNAL MODULE: ./src/components/templates/doctor/detail/useDoctorDetailViewModel.tsx + 4 modules
var useDoctorDetailViewModel = __webpack_require__(8500);
// EXTERNAL MODULE: ./src/constants/logs/doctor/index.ts
var logs_doctor = __webpack_require__(93286);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSlideTab/index.tsx
var DNSlideTab = __webpack_require__(67788);
// EXTERNAL MODULE: ./src/hooks/review/useReviewReportModal.tsx
var useReviewReportModal = __webpack_require__(68512);
// EXTERNAL MODULE: ./src/components/atom/icon/ArrowsButtonDownMin.tsx
var ArrowsButtonDownMin = __webpack_require__(92803);
;// CONCATENATED MODULE: ./src/components/atom/icon/doctor/CareerBadge.tsx

var CareerBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 2H4C3.17157 2 2.5 2.67158 2.5 3.5V13.3742C2.5 13.9457 2.82474 14.4676 3.33747 14.72L9.33747 17.6738C9.75522 17.8795 10.2448 17.8795 10.6625 17.6738L16.6625 14.72C17.1753 14.4676 17.5 13.9457 17.5 13.3742V3.5C17.5 2.67157 16.8284 2 16 2Z",
                fill: "#C6CACE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 11.4521L7.93991 12.6751C7.84891 12.7322 7.75376 12.7566 7.65448 12.7485C7.5552 12.7403 7.46833 12.7077 7.39387 12.6506C7.31941 12.5936 7.26149 12.5222 7.22013 12.4366C7.17876 12.351 7.17049 12.2552 7.19531 12.1492L7.74135 9.83771L5.91706 8.28449C5.83433 8.21111 5.78262 8.12754 5.76193 8.03378C5.74125 7.94001 5.74745 7.84829 5.78055 7.7586C5.81364 7.66891 5.86328 7.59553 5.92947 7.53846C5.99566 7.48138 6.08667 7.44469 6.20249 7.42839L8.61006 7.22048L9.54082 5.04352C9.58219 4.94568 9.64631 4.8723 9.73318 4.82338C9.82005 4.77446 9.90899 4.75 10 4.75C10.091 4.75 10.1799 4.77446 10.2668 4.82338C10.3537 4.8723 10.4178 4.94568 10.4592 5.04352L11.3899 7.22048L13.7975 7.42839C13.9133 7.44469 14.0043 7.48138 14.0705 7.53846C14.1367 7.59553 14.1864 7.66891 14.2195 7.7586C14.2525 7.84829 14.2588 7.94001 14.2381 8.03378C14.2174 8.12754 14.1657 8.21111 14.0829 8.28449L12.2586 9.83771L12.8047 12.1492C12.8295 12.2552 12.8212 12.351 12.7799 12.4366C12.7385 12.5222 12.6806 12.5936 12.6061 12.6506C12.5317 12.7077 12.4448 12.7403 12.3455 12.7485C12.2462 12.7566 12.1511 12.7322 12.0601 12.6751L10 11.4521Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var doctor_CareerBadge = (CareerBadge);

;// CONCATENATED MODULE: ./src/components/atom/icon/doctor/RepresentativeCareerBadge.tsx

var RepresentativeCareerBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 2H4C3.17157 2 2.5 2.67158 2.5 3.5V13.3742C2.5 13.9457 2.82474 14.4676 3.33747 14.72L9.33747 17.6738C9.75522 17.8795 10.2448 17.8795 10.6625 17.6738L16.6625 14.72C17.1753 14.4676 17.5 13.9457 17.5 13.3742V3.5C17.5 2.67157 16.8284 2 16 2Z",
                fill: "#FD7E14"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 11.4521L7.93991 12.6751C7.84891 12.7322 7.75376 12.7566 7.65448 12.7485C7.5552 12.7403 7.46833 12.7077 7.39387 12.6506C7.31941 12.5936 7.26149 12.5222 7.22013 12.4366C7.17876 12.351 7.17049 12.2552 7.19531 12.1492L7.74135 9.83771L5.91706 8.28449C5.83433 8.21111 5.78262 8.12754 5.76193 8.03378C5.74125 7.94001 5.74745 7.84829 5.78055 7.7586C5.81364 7.66891 5.86328 7.59553 5.92947 7.53846C5.99566 7.48138 6.08667 7.44469 6.20249 7.42839L8.61006 7.22048L9.54082 5.04352C9.58219 4.94568 9.64631 4.8723 9.73318 4.82338C9.82005 4.77446 9.90899 4.75 10 4.75C10.091 4.75 10.1799 4.77446 10.2668 4.82338C10.3537 4.8723 10.4178 4.94568 10.4592 5.04352L11.3899 7.22048L13.7975 7.42839C13.9133 7.44469 14.0043 7.48138 14.0705 7.53846C14.1367 7.59553 14.1864 7.66891 14.2195 7.7586C14.2525 7.84829 14.2588 7.94001 14.2381 8.03378C14.2174 8.12754 14.1657 8.21111 14.0829 8.28449L12.2586 9.83771L12.8047 12.1492C12.8295 12.2552 12.8212 12.351 12.7799 12.4366C12.7385 12.5222 12.6806 12.5936 12.6061 12.6506C12.5317 12.7077 12.4448 12.7403 12.3455 12.7485C12.2462 12.7566 12.1511 12.7322 12.0601 12.6751L10 11.4521Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var doctor_RepresentativeCareerBadge = (RepresentativeCareerBadge);

// EXTERNAL MODULE: ./src/components/common/KakaoMap/index.tsx
var KakaoMap = __webpack_require__(46213);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/Section/Section.tsx




function Section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 28px 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  align-self: stretch;\n"
    ]);
    Section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 24px;\n"
    ]);
    Section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Section_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Section_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Section_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 16px;\n\n  ",
        ";\n"
    ]);
    Section_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Section_Section = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(SectionWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: children
    }));
};
var SectionTitle = function(_param) {
    var title = _param.title, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitleRow, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_Title, {
                children: title
            }),
            children
        ]
    }));
};
var SectionDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_Divider, {});
};
Section_Section.Title = SectionTitle;
Section_Section.Divider = SectionDivider;
/* harmony default export */ var components_Section_Section = (Section_Section);
var SectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba77c555-0"
})(Section_templateObject());
var SectionTitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba77c555-1"
})(Section_templateObject1());
var Section_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba77c555-2"
})(Section_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI19SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var Section_Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba77c555-3"
})(Section_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray30, ";\n    border-top: 1px solid ").concat(theme.color.gray50, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorIntroduction/DoctorBadges.tsx

function DoctorBadges_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 24px;\n  gap: 20px;\n  flex-wrap: wrap;\n  align-self: stretch;\n  flex-direction: column;\n"
    ]);
    DoctorBadges_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorBadges_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n"
    ]);
    DoctorBadges_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorBadges_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  margin-right: 16px;\n"
    ]);
    DoctorBadges_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorBadges_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"
    ]);
    DoctorBadges_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorBadges_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorBadges_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorBadges_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorBadges_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DoctorBadges = function(param) {
    var doctorBadges = param.doctorBadges;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                    title: "의사 정보"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                    children: doctorBadges.map(function(badge, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeIcon, {
                                    src: badge.iconUrl
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeContentWrap, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeTitle, {
                                            children: badge.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeDescription, {
                                            children: badge.description
                                        })
                                    ]
                                })
                            ]
                        }, "badge_".concat(index));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DoctorIntroduction_DoctorBadges = (DoctorBadges);
var Badges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4279d274-0"
})(DoctorBadges_templateObject());
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4279d274-1"
})(DoctorBadges_templateObject1());
var BadgeIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4279d274-2"
})(DoctorBadges_templateObject2());
var BadgeContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4279d274-3"
})(DoctorBadges_templateObject3());
var BadgeTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4279d274-4"
})(DoctorBadges_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, "\n    color: ").concat(theme.color.gray700, "\n  ");
});
var BadgeDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4279d274-5"
})(DoctorBadges_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, "\n    color: ").concat(theme.color.gray300, "\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorIntroduction/DoctorNotice.tsx

function DoctorNotice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 24px;\n  width: 100%;\n"
    ]);
    DoctorNotice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorNotice_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-self: stretch;\n  gap: 8px;\n  margin-bottom: 8px;\n"
    ]);
    DoctorNotice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorNotice_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 22px;\n  padding: 0 4px;\n  border-radius: 4px;\n  align-items: center;\n  background-color: ",
        ";\n  ",
        ";\n"
    ]);
    DoctorNotice_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorNotice_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        ";\n"
    ]);
    DoctorNotice_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorNotice_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: stretch;\n  text-overflow: ellipsis;\n  ",
        ";\n  line-height: 24px !important;\n"
    ]);
    DoctorNotice_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var DoctorNotice = function(param) {
    var notice = param.notice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeTitleRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBadge, {
                                children: "공지"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeTitle, {
                                children: notice.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeContent, {
                        children: notice.content
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DoctorIntroduction_DoctorNotice = (DoctorNotice);
var NoticeWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2536e54-0"
})(DoctorNotice_templateObject());
var NoticeTitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2536e54-1"
})(DoctorNotice_templateObject1());
var NoticeBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2536e54-2"
})(DoctorNotice_templateObject2(), theme/* default.color.red600 */.Z.color.red600, function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI13SB, ";\n    color: ").concat(_$theme.color.white, ";\n  ");
});
var NoticeTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2536e54-3"
})(DoctorNotice_templateObject3(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15SB, ";\n    color: ").concat(_$theme.color.gray700, ";\n  ");
});
var NoticeContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2536e54-4"
})(DoctorNotice_templateObject4(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI14R, ";\n    color: ").concat(_$theme.color.gray700, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorIntroduction/DoctorOperationTimeTable.tsx

function DoctorOperationTimeTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 24px;\n  border-radius: 8px;\n"
    ]);
    DoctorOperationTimeTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 8px;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 20px;\n"
    ]);
    DoctorOperationTimeTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n"
    ]);
    DoctorOperationTimeTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    DoctorOperationTimeTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorOperationTimeTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorOperationTimeTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DoctorOperationTimeTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n"
    ]);
    DoctorOperationTimeTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var getWeekDayInfo = function(weekDay) {
    switch(weekDay){
        case 1:
            return {
                day: "월요일",
                dayColor: theme/* default.color.gray400 */.Z.color.gray400
            };
        case 2:
            return {
                day: "화요일",
                dayColor: theme/* default.color.gray400 */.Z.color.gray400
            };
        case 3:
            return {
                day: "수요일",
                dayColor: theme/* default.color.gray400 */.Z.color.gray400
            };
        case 4:
            return {
                day: "목요일",
                dayColor: theme/* default.color.gray400 */.Z.color.gray400
            };
        case 5:
            return {
                day: "금요일",
                dayColor: theme/* default.color.gray400 */.Z.color.gray400
            };
        case 6:
            return {
                day: "토요일",
                dayColor: theme/* default.color.blue700 */.Z.color.blue700
            };
        case 7:
            return {
                day: "일요일",
                dayColor: theme/* default.color.red700 */.Z.color.red700
            };
        default:
            return {
                day: "공휴일",
                dayColor: theme/* default.color.red700 */.Z.color.red700
            };
    }
};
var DoctorOperationTimeTable = function(param) {
    var duties = param.duties, todayDuty = param.todayDuty;
    var breakTimeDisplay = (todayDuty === null || todayDuty === void 0 ? void 0 : todayDuty.isClosed) ? "휴무" : (todayDuty === null || todayDuty === void 0 ? void 0 : todayDuty.hasBreakTime) ? "".concat(todayDuty.breakStartTime, " ~ ").concat(todayDuty.breakEndTime) : "없음";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
                children: duties.map(function(duty) {
                    var ref = getWeekDayInfo(duty.weekDay), day = ref.day, dayColor = ref.dayColor;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DutyWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                color: dayColor,
                                children: day
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                                children: duty.isClosed ? "휴무" : "".concat(duty.openTime, " ~ ").concat(duty.closeTime)
                            })
                        ]
                    }, duty.weekDay);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreakTime, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorOperationTimeTable_StyledDivider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DutyWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                children: "휴게시간"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                                children: breakTimeDisplay
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DoctorIntroduction_DoctorOperationTimeTable = (DoctorOperationTimeTable);
var BoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-0"
})(DoctorOperationTimeTable_templateObject());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-1"
})(DoctorOperationTimeTable_templateObject1());
var DutyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-2"
})(DoctorOperationTimeTable_templateObject2());
var BreakTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-3"
})(DoctorOperationTimeTable_templateObject3());
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-4"
})(DoctorOperationTimeTable_templateObject4(), function(param) {
    var theme = param.theme, color = param.color;
    return "\n    ".concat(theme.typography.UI14R, ";\n    color: ").concat(color !== null && color !== void 0 ? color : theme.color.gray400, ";\n  ");
});
var Time = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-760dc116-5"
})(DoctorOperationTimeTable_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var DoctorOperationTimeTable_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(atom_Divider/* default */.Z).withConfig({
    componentId: "sc-760dc116-6"
})(DoctorOperationTimeTable_templateObject6());

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorIntroduction/DoctorTreatments.tsx

function DoctorTreatments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 24px;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-self: stretch;\n"
    ]);
    DoctorTreatments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorTreatments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 8px;\n  height: 28px;\n  border-radius: 4px;\n  justify-content: center;\n  align-items: center;\n  ",
        "\n"
    ]);
    DoctorTreatments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorTreatments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DoctorTreatments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var MAX_DOCTOR_TREATMENT_COUNT = 12;
var DoctorTreatments = function(param) {
    var doctorTreatments = param.doctorTreatments;
    var unfold = function unfold() {
        setIsUnfoldable(!isUnfoldable);
    };
    var ref = (0,react.useState)(doctorTreatments.length > MAX_DOCTOR_TREATMENT_COUNT), isUnfoldable = ref[0], setIsUnfoldable = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                    title: "진료 증상"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Treatments, {
                    children: !isUnfoldable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: doctorTreatments.map(function(treatment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Treatment, {
                                children: treatment.treatmentName
                            }, treatment.treatmentId);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            doctorTreatments.slice(0, MAX_DOCTOR_TREATMENT_COUNT).map(function(treatment) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Treatment, {
                                    children: treatment.treatmentName
                                }, treatment.treatmentId);
                            }),
                            isUnfoldable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreButton, {
                                    onClick: unfold,
                                    children: "..."
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var DoctorIntroduction_DoctorTreatments = (DoctorTreatments);
var Treatments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-897a382f-0"
})(DoctorTreatments_templateObject());
var Treatment = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-897a382f-1"
})(DoctorTreatments_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray50, ";\n    ").concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray600, "\n  ");
});
var MoreButton = (0,styled_components_browser_esm/* default */.ZP)(Treatment).withConfig({
    componentId: "sc-897a382f-2"
})(DoctorTreatments_templateObject2());

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorIntroduction/DoctorIntroduction.tsx

function DoctorIntroduction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    DoctorIntroduction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 0 24px;\n"
    ]);
    DoctorIntroduction_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    DoctorIntroduction_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: stretch;\n  margin-bottom: 12px;\n\n  ",
        "\n"
    ]);
    DoctorIntroduction_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: stretch;\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    DoctorIntroduction_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 20px;\n"
    ]);
    DoctorIntroduction_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  overflow-wrap: anywhere;\n"
    ]);
    DoctorIntroduction_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  overflow: hidden;\n"
    ]);
    DoctorIntroduction_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: rebeccapurple;\n  box-sizing: content-box;\n"
    ]);
    DoctorIntroduction_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DoctorIntroduction_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 40px;\n  width: 100%;\n  right: 0;\n  bottom: ",
        "px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    DoctorIntroduction_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: ",
        "px;\n  ",
        ";\n  svg {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  gap: 2px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 64px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  width: 100%;\n  height: 196px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 108px;\n  margin-top: -108px;\n  display: block;\n  visibility: hidden;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}














var IMAGE_SHOW_MORE_BUTTON_HEIGHT = 56;
var IMAGE_SHOW_MIN_HEIGHT = 280;
var DoctorIntroduction = function(param) {
    var doctorDetailViewModel = param.doctorDetailViewModel;
    var ref;
    var doctorDetailImageRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isShowMoreImageButton = ref1[0], setIsShowMoreImageButton = ref1[1];
    (0,react.useEffect)(function() {
        if (!(doctorDetailImageRef === null || doctorDetailImageRef === void 0 ? void 0 : doctorDetailImageRef.current)) return;
        if (doctorDetailImageRef.current.clientHeight > IMAGE_SHOW_MIN_HEIGHT) {
            setIsShowMoreImageButton(true);
        }
    }, [
        doctorDetailImageRef,
        (ref = doctorDetailImageRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnchorArea, {
                id: useDoctorDetailViewModel/* DoctorDetailTabType.DoctorProfile */.DP.DoctorProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorIntroduction_Wrapper, {
                children: [
                    doctorDetailViewModel.hasNoNotice() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_DoctorNotice, {
                                notice: doctorDetailViewModel.doctorDetail.notice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                        ]
                    }),
                    doctorDetailViewModel.hasNoBadge() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_DoctorBadges, {
                                doctorBadges: doctorDetailViewModel.doctorDetail.badges
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                        ]
                    }),
                    doctorDetailViewModel.hasNoCareer() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                        title: "경력"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerList, {
                                        children: doctorDetailViewModel.doctorDetail.doctor.career.map(function(career) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Career, {
                                                children: [
                                                    career.isRepresentative ? /*#__PURE__*/ (0,jsx_runtime.jsx)(doctor_RepresentativeCareerBadge, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(doctor_CareerBadge, {}),
                                                    doctorDetailViewModel.getCareerDisplayText(career)
                                                ]
                                            }, "career-".concat(career.id));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "의사 소개"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroduceWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleIntroduce, {
                                        children: doctorDetailViewModel.doctorDetail.doctor.simpleIntroduce
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Introduce, {
                                        children: doctorDetailViewModel.doctorDetail.doctor.introduce
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                        isOpen: !isShowMoreImageButton,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
                                children: doctorDetailViewModel.doctorDetail.doctor.detailImageUrls.map(function(url) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_Image, {
                                        ref: doctorDetailImageRef,
                                        alt: "의사 상세 이미지",
                                        src: url
                                    }, "doctor-detail-".concat(url));
                                })
                            }),
                            isShowMoreImageButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGradient, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageShowMoreButton, {
                                        onClick: function() {
                                            return setIsShowMoreImageButton(false);
                                        },
                                        children: [
                                            "더 보기",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsButtonDownMin/* default */.Z, {
                                                color: theme/* default.color.gray600 */.Z.color.gray600
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_DoctorTreatments, {
                        doctorTreatments: doctorDetailViewModel.getDoctorTreatments()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "".concat(doctorDetailViewModel.diagnosisContactType, " 진료 시간")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_DoctorOperationTimeTable, {
                                duties: doctorDetailViewModel.getDoctorDuties(),
                                todayDuty: doctorDetailViewModel.doctorDetail.doctor.todayDuty
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "병원 위치"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hospital, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_HospitalName, {
                                                children: doctorDetailViewModel.doctorDetail.hospital.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalAddress, {
                                                children: "".concat(doctorDetailViewModel.doctorDetail.hospital.roadAddress, ", ").concat(doctorDetailViewModel.doctorDetail.hospital.detailAddress)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalCallButton, {
                                        onClick: doctorDetailViewModel.callHospital,
                                        children: "전화"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMap, {
                                onClick: doctorDetailViewModel.openMap,
                                latitude: Number(doctorDetailViewModel.doctorDetail.hospital.latitude),
                                longitude: Number(doctorDetailViewModel.doctorDetail.hospital.longitude)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var DoctorIntroduction_DoctorIntroduction = (DoctorIntroduction);
var DoctorIntroduction_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-0"
})(DoctorIntroduction_templateObject());
var CareerList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-1"
})(DoctorIntroduction_templateObject1());
var Career = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-2"
})(DoctorIntroduction_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var SimpleIntroduce = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-3"
})(DoctorIntroduction_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var Introduce = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-4"
})(DoctorIntroduction_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14R, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var DoctorSection = (0,styled_components_browser_esm/* default */.ZP)(components_Section_Section).withConfig({
    componentId: "sc-94a7327b-5"
})(DoctorIntroduction_templateObject5());
var IntroduceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-6"
})(DoctorIntroduction_templateObject6());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-7"
})(DoctorIntroduction_templateObject7(), function(param) {
    var isOpen = param.isOpen;
    return "\n    height: ".concat(isOpen ? "initial" : IMAGE_SHOW_MIN_HEIGHT + IMAGE_SHOW_MORE_BUTTON_HEIGHT, "px;\n  \n  ");
});
var Images = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-8"
})(DoctorIntroduction_templateObject8());
var ImageGradient = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-9"
})(DoctorIntroduction_templateObject9(), IMAGE_SHOW_MORE_BUTTON_HEIGHT - 1);
var ImageShowMoreButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-94a7327b-10"
})(_templateObject10(), IMAGE_SHOW_MORE_BUTTON_HEIGHT - 1, function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    border-top: 1px solid ").concat(theme.color.gray50, ";\n  ");
});
var DoctorIntroduction_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-94a7327b-11"
})(_templateObject11());
var Hospital = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-12"
})(_templateObject12());
var HospitalInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-13"
})(_templateObject13());
var DoctorIntroduction_HospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, "\n    color: ").concat(theme.color.gray700, "\n  ");
});
var HospitalAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-15"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, "\n    color: ").concat(theme.color.gray300, "\n  ");
});
var HospitalCallButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-16"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    ").concat(theme.typography.UI14SB, "\n    color: ").concat(theme.color.gray600, "\n  ");
});
var StyledMap = (0,styled_components_browser_esm/* default */.ZP)(KakaoMap/* default */.Z).withConfig({
    componentId: "sc-94a7327b-17"
})(_templateObject17());
var AnchorArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a7327b-18"
})(_templateObject18());

// EXTERNAL MODULE: ./src/components/molecules/detail/EmptyView/EmptyView.tsx + 1 modules
var EmptyView = __webpack_require__(16382);
// EXTERNAL MODULE: ./src/components/templates/doctor/detail/components/CategoryHeader/CategoryHeader.tsx
var CategoryHeader = __webpack_require__(37893);
// EXTERNAL MODULE: ./src/components/templates/doctor/detail/components/DoctorReview/DoctorReviewSkeleton.tsx
var DoctorReviewSkeleton = __webpack_require__(56635);
// EXTERNAL MODULE: ./src/components/templates/doctor/detail/components/DoctorReview/DoctorReviewSummary.tsx
var DoctorReviewSummary = __webpack_require__(55481);
// EXTERNAL MODULE: ./src/components/templates/doctor/detail/components/DoctorReview/ReviewSortKeySelect.tsx + 1 modules
var ReviewSortKeySelect = __webpack_require__(88363);
// EXTERNAL MODULE: ./src/components/templates/review/ReviewItem.tsx + 3 modules
var ReviewItem = __webpack_require__(5635);
// EXTERNAL MODULE: ./src/models/review/review.ts
var review_review = __webpack_require__(84958);
;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorReview/BestReviewItem.tsx

function BestReviewItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    BestReviewItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BestReviewItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    BestReviewItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BestReviewItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 20px 24px 0 24px;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    BestReviewItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BestReviewItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1px 4px;\n  border-radius: 2px;\n  gap: 2px;\n  background: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    BestReviewItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BestReviewItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    BestReviewItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BestReviewItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    BestReviewItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var BestReviewItem = function(param) {
    var review = param.review, onClickMenu = param.onClickMenu, clickLikeReview = param.clickLikeReview, isOtherUsersPrivateReview = param.isOtherUsersPrivateReview;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItemContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewItemWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BestBadgeWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BestBadge, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                    name: "thumb_up",
                                    size: 14,
                                    filled: true,
                                    color: theme/* default.color.white */.Z.color.white
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BestBadgeText, {
                                    style: {
                                        color: theme/* default.color.white */.Z.color.white
                                    },
                                    children: "BEST"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BestReviewGuideText, {
                            style: {
                                color: theme/* default.color.blue700 */.Z.color.blue700
                            },
                            children: "가장 도움이 된 후기예요"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* default */.Z, {
                    review: review,
                    onClickMenu: onClickMenu,
                    isHideContent: isOtherUsersPrivateReview(review),
                    clickLikeReview: function() {
                        return clickLikeReview(Number(review.id), review.isLiked, review_review/* EReviewType.BEST */.Fj.BEST);
                    },
                    reviewTargetType: review_review/* ReviewTargetType.DOCTOR */.fr.DOCTOR
                })
            ]
        })
    });
};
/* harmony default export */ var DoctorReview_BestReviewItem = (BestReviewItem);
var ReviewItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a2431cf-0"
})(BestReviewItem_templateObject());
var ReviewItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a2431cf-1"
})(BestReviewItem_templateObject1());
var BestBadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a2431cf-2"
})(BestReviewItem_templateObject2());
var BestBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a2431cf-3"
})(BestReviewItem_templateObject3(), theme/* default.color.blue500 */.Z.color.blue500);
var BestBadgeText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4a2431cf-4"
})(BestReviewItem_templateObject4(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI12M, ";\n    color: ").concat(_$theme.color.white, ";\n  ");
});
var BestReviewGuideText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4a2431cf-5"
})(BestReviewItem_templateObject5(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI13SB, ";\n    color: ").concat(_$theme.color.blue700, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/DoctorReview/DoctorReview.tsx

function DoctorReview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 28px 0;\n"
    ]);
    DoctorReview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 8px;\n  ",
        "\n"
    ]);
    DoctorReview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px 0;\n\n  ",
        "\n"
    ]);
    DoctorReview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    DoctorReview_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-top: 20px;\n"
    ]);
    DoctorReview_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DoctorReview_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    DoctorReview_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 108px;\n  margin-top: -108px;\n  display: block;\n  visibility: hidden;\n"
    ]);
    DoctorReview_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 16px 0;\n\n  svg {\n    margin-left: 8px;\n  }\n\n  ",
        "\n"
    ]);
    DoctorReview_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DoctorReview_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 8px;\n  background-color: ",
        ";\n"
    ]);
    DoctorReview_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




















var DOCTOR_REVIEW_SHOW_LENGTH = 3;
var DoctorReview = function(param) {
    var isMobile = param.isMobile, doctorReviewsViewModel = param.doctorReviewsViewModel;
    var ref, ref1, ref2;
    var ref3 = (0,useReviewReportModal/* default */.Z)(), showReportModal = ref3.showReportModal, openReportModal = ref3.openReportModal, onCloseReportModal = ref3.onCloseReportModal, reportItems = ref3.reportItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReview_AnchorArea, {
                id: useDoctorDetailViewModel/* DoctorDetailTabType.Review */.DP.Review
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !((ref = doctorReviewsViewModel.reviews) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "진료 후기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyView/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyText, {
                                    children: "아직 남겨진 후기가 없어요."
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorReview_Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "진료 후기",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalReviewCount, {
                                    children: (0,format/* formatPriceComma */.dM)(doctorReviewsViewModel.totalCount)
                                })
                            }),
                            doctorReviewsViewModel.bestDoctorReview && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReview_BestReviewItem, {
                                        onClickMenu: openReportModal,
                                        clickLikeReview: doctorReviewsViewModel.clickLikeReview,
                                        review: doctorReviewsViewModel.bestDoctorReview,
                                        isOtherUsersPrivateReview: doctorReviewsViewModel.isOtherUsersPrivateReview
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gap, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSummaryWrapper, {
                                alignCenter: isMobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReviewSummary/* default */.Z, {
                                    averageRating: "".concat((ref1 = doctorReviewsViewModel.doctorDetail) === null || ref1 === void 0 ? void 0 : ref1.doctor.averageRating.toFixed(1)),
                                    reviewTagGroups: doctorReviewsViewModel.getReviewStatisticGroupsForSummary(),
                                    hideReviewSummary: doctorReviewsViewModel.isReviewNotEnough()
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gap, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryAndSortWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader/* default */.Z, {
                                        children: doctorReviewsViewModel.getReviewCategories().map(function(category) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryHeader/* default.Item */.Z.Item, {
                                                onClick: function() {
                                                    return doctorReviewsViewModel.selectReviewCategory(category);
                                                },
                                                isSelected: doctorReviewsViewModel.isReviewCategorySelected(category),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: category.name
                                                    }),
                                                    doctorReviewsViewModel.getReviewCountByCategory(category)
                                                ]
                                            }, "review-category-".concat(category.id, "-").concat(category.diagnosisType));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortHeader, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSortKeySelect/* default */.Z, {
                                            doctorReviewsViewModel: doctorReviewsViewModel
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewList, {
                                children: !doctorReviewsViewModel.reviews.length && doctorReviewsViewModel.isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReviewSkeleton/* default */.Z, {}) : doctorReviewsViewModel.reviews.slice(0, DOCTOR_REVIEW_SHOW_LENGTH).map(function(review) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* default */.Z, {
                                        review: review,
                                        onClickMenu: openReportModal,
                                        isHideContent: doctorReviewsViewModel.isOtherUsersPrivateReview(review),
                                        clickLikeReview: function() {
                                            return doctorReviewsViewModel.clickLikeReview(Number(review.id), review.isLiked, review_review/* EReviewType.NORMAL */.Fj.NORMAL);
                                        },
                                        reviewTargetType: review_review/* ReviewTargetType.DOCTOR */.fr.DOCTOR
                                    }, "review-".concat(review.id));
                                })
                            }),
                            doctorReviewsViewModel.totalCount > DOCTOR_REVIEW_SHOW_LENGTH && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                params: {
                                    eventName: "".concat(logs_doctor/* DoctorDetailLog.click_review_all */.d.click_review_all, "_").concat((ref2 = doctorReviewsViewModel.selectedReviewCategory.diagnosisType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), "_").concat(doctorReviewsViewModel.selectedReviewCategory.id)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewAllButton, {
                                    onClick: doctorReviewsViewModel.onClickViewAll,
                                    children: [
                                        "전체보기",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsButtonRightMin/* default */.Z, {
                                            color: theme/* default.color.gray600 */.Z.color.gray600
                                        })
                                    ]
                                })
                            }),
                            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                                isVisible: showReportModal,
                                selectList: reportItems,
                                onClose: onCloseReportModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var DoctorReview_DoctorReview = (DoctorReview);
var DoctorReview_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-0"
})(DoctorReview_templateObject());
var TotalReviewCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-1"
})(DoctorReview_templateObject1(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI19SB, ";\n    color: ").concat(_$theme.color.primary700, ";\n  ");
});
var ReviewSummaryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-2"
})(DoctorReview_templateObject2(), function(param) {
    var alignCenter = param.alignCenter;
    return "\n    justify-content ".concat(alignCenter ? "center" : "flex-start", "\n  ");
});
var ReviewList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-3"
})(DoctorReview_templateObject3());
var CategoryAndSortWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-4"
})(DoctorReview_templateObject4());
var SortHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-5"
})(DoctorReview_templateObject5());
var EmptyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-6"
})(DoctorReview_templateObject6(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI18M, ";\n    color:").concat(_$theme.color.gray700, ";\n  ");
});
var DoctorReview_AnchorArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-7"
})(DoctorReview_templateObject7());
var ViewAllButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-18b59498-8"
})(DoctorReview_templateObject8(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI16M, ";\n    color:").concat(_$theme.color.gray600, ";\n  ");
});
var Gap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18b59498-9"
})(DoctorReview_templateObject9(), theme/* default.color.gray30 */.Z.color.gray30);

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/F2FGuideBottomSheet/F2FGuideBottomSheet.tsx

function F2FGuideBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px 0;\n"
    ]);
    F2FGuideBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 4px;\n"
    ]);
    F2FGuideBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  ",
        ";\n"
    ]);
    F2FGuideBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  ",
        ";\n"
    ]);
    F2FGuideBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    F2FGuideBottomSheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n"
    ]);
    F2FGuideBottomSheet_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function F2FGuideBottomSheet_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 122px;\n"
    ]);
    F2FGuideBottomSheet_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var F2FGuideBottomSheet = function(param) {
    var isOpened = param.isOpened, onClose = param.onClose, onClickF2FGuideBottomSheet = param.onClickF2FGuideBottomSheet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheet/* default */.ZP, {
        index: 10,
        isOpened: isOpened,
        onClickOverlay: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(F2FGuideBottomSheet_Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(F2FGuideBottomSheet_Contents, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(F2FGuideBottomSheet_Title, {
                            children: "비대면 진료가 아닌 대면 진료예요"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmphasisSubTitle, {
                                    children: "병원 방문이 필수"
                                }),
                                "이므로 예약 시 참고해 주세요."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionImg, {
                                src: "/images/diet_diagnosis_bottom_sheet_guide.png",
                                alt: "diet_diagnosis_bottom_sheet_guide"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                    text: "병원 방문 예약",
                    onClick: onClickF2FGuideBottomSheet
                })
            })
        ]
    });
};
/* harmony default export */ var F2FGuideBottomSheet_F2FGuideBottomSheet = (F2FGuideBottomSheet);
var F2FGuideBottomSheet_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b59dd43-0"
})(F2FGuideBottomSheet_templateObject());
var F2FGuideBottomSheet_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b59dd43-1"
})(F2FGuideBottomSheet_templateObject1());
var F2FGuideBottomSheet_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b59dd43-2"
})(F2FGuideBottomSheet_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray800, ";\n  ");
});
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b59dd43-3"
})(F2FGuideBottomSheet_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var EmphasisSubTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7b59dd43-4"
})(F2FGuideBottomSheet_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, ";\n    color: ").concat(theme.color.red800, ";\n  ");
});
var DescriptionImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b59dd43-5"
})(F2FGuideBottomSheet_templateObject5());
var DescriptionImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7b59dd43-6"
})(F2FGuideBottomSheet_templateObject6());

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/NonBenefitPrice/PointTermInfo.tsx

function PointTermInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: baseline;\n"
    ]);
    PointTermInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    PointTermInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background-color: ",
        ";\n  border-radius: 8px;\n  margin: 0 24px;\n  padding: 16px;\n  align-self: stretch;\n"
    ]);
    PointTermInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: flex;\n  gap: 4px;\n"
    ]);
    PointTermInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    PointTermInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    PointTermInfo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PointTermInfo_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  justify-content: flex-start;\n  white-space: break-spaces;\n\n  ",
        "\n"
    ]);
    PointTermInfo_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var TERM_LIST = [
    "포인트 사용은 닥터나우 앱 결제 시에만 적용돼요.",
    "비급여 진료 시에 최대 49% 사용이 가능하며,\n100P 이상부터 사용할 수 있습니다.", 
];
var PointTermInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointTermInfo_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointTermInfo_Title, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                        name: "info",
                        size: 20,
                        color: theme/* default.color.blue500 */.Z.color.blue500
                    }),
                    "결제 안내"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionWrapper, {
                children: TERM_LIST.map(function(term) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermListDecoration, {
                                children: "•"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Term, {
                                children: term
                            })
                        ]
                    }, term);
                })
            })
        ]
    });
};
/* harmony default export */ var NonBenefitPrice_PointTermInfo = (PointTermInfo);
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df6341e5-0"
})(PointTermInfo_templateObject());
var TermListDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df6341e5-1"
})(PointTermInfo_templateObject1(), theme/* default.color.gray200 */.Z.color.gray200);
var PointTermInfo_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df6341e5-2"
})(PointTermInfo_templateObject2(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray20;
});
var PointTermInfo_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df6341e5-3"
})(PointTermInfo_templateObject3(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.blue500;
}, function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI15M;
});
var DescriptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df6341e5-4"
})(PointTermInfo_templateObject4());
var Term = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-df6341e5-5"
})(PointTermInfo_templateObject6(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(PointTermInfo_templateObject5(), _$theme.typography.UI13M, _$theme.color.gray400);
});

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/components/NonBenefitPrice/NonBenefitPrice.tsx

function NonBenefitPrice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-bottom: 16px;\n"
    ]);
    NonBenefitPrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitPrice_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        ":not(:last-child) {\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n    border-bottom-style: solid;\n  }\n\n  ",
        ":not(:first-child) {\n    padding-top: 16px;\n  }\n"
    ]);
    NonBenefitPrice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitPrice_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 0px 24px;\n"
    ]);
    NonBenefitPrice_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitPrice_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitPrice_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitPrice_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitPrice_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitPrice_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 108px;\n  margin-top: -108px;\n  display: block;\n  visibility: hidden;\n"
    ]);
    NonBenefitPrice_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






// eslint-disable-next-line import/order


var NonBenefitPrice = function(param) {
    var doctorDetailViewModel = param.doctorDetailViewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitPrice_AnchorArea, {
                id: useDoctorDetailViewModel/* DoctorDetailTabType.NonBenefitPrice */.DP.NonBenefitPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: useDoctorDetailViewModel/* DoctorDetailTabType.NonBenefitPrice */.DP.NonBenefitPrice,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Section_Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Title, {
                                title: "비급여 진료비",
                                children: doctorDetailViewModel.isF2FDiagnosis() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-1 items-center justify-end gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CheckItem */.M1, {
                                        label: "원내처방",
                                        checkboxProps: {
                                            checked: doctorDetailViewModel.isWithDispensation,
                                            onCheckedChange: doctorDetailViewModel.toggleWithDispensation
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-4",
                                children: doctorDetailViewModel.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full items-center justify-between rounded-lg bg-gray-20 p-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "h-5 w-5",
                                                    alt: "포인트 아이콘",
                                                    src: "/images/point/point.png"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-15m text-gray-700",
                                                    children: " 포인트 사용시"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Toggle */.ZD, {
                                            checked: doctorDetailViewModel.isPointPriceVisible,
                                            onChange: doctorDetailViewModel.togglePointPrice
                                        })
                                    ]
                                })
                            }),
                            doctorDetailViewModel.shouldShowNonBenefitCategoryHeader() && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader/* default */.Z, {
                                children: doctorDetailViewModel.getNonBenefitPriceCategories().map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader/* default.Item */.Z.Item, {
                                        isSelected: doctorDetailViewModel.isCategorySelected(category),
                                        onClick: function() {
                                            return doctorDetailViewModel.selectNonBenefitPriceCategory(category);
                                        },
                                        children: category.name
                                    }, "non-benefit-price-category-".concat(category.id));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentPriceList, {
                                children: doctorDetailViewModel.getNonBenefitTreatmentPriceList().map(function(treatment) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SameCategoryWrapper, {
                                        children: treatment.medicines.map(function(medicine) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentPriceItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TreatmentPriceItemMedicineLabel, {
                                                        children: "".concat(medicine.treatmentMedicineName, ", ").concat(medicine.unitDisplayName).concat(medicine.unitTypeDisplayName)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TreatmentPriceItemPriceLabel, {
                                                        children: [
                                                            (0,format/* formatPriceComma */.dM)(doctorDetailViewModel.isPointPriceVisible ? medicine.priceOnUsingPoint : medicine.originalPrice),
                                                            "원"
                                                        ]
                                                    })
                                                ]
                                            }, "non-benefit-treatment-".concat(treatment.id, "-").concat(medicine.id));
                                        })
                                    }, "non-benefit-treatment-".concat(treatment.id));
                                })
                            }),
                            doctorDetailViewModel.shouldShowPointTermInfo() && /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitPrice_PointTermInfo, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section_Section.Divider, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var NonBenefitPrice_NonBenefitPrice = (NonBenefitPrice);
var SameCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-0"
})(NonBenefitPrice_templateObject());
var TreatmentPriceList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-1"
})(NonBenefitPrice_templateObject1(), SameCategoryWrapper, function(param) {
    var theme = param.theme;
    return theme.color.gray40;
}, SameCategoryWrapper);
var TreatmentPriceItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-2"
})(NonBenefitPrice_templateObject2());
var TreatmentPriceItemMedicineLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-3"
})(NonBenefitPrice_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI14M, ";\n        color:").concat(theme.color.gray700, ";\n    ");
});
var TreatmentPriceItemPriceLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-4"
})(NonBenefitPrice_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI14M, ";\n        color:").concat(theme.color.primary700, ";\n    ");
});
var NonBenefitPrice_AnchorArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d7fd4e-5"
})(NonBenefitPrice_templateObject5());

;// CONCATENATED MODULE: ./src/components/templates/doctor/detail/DoctorDetailTemplate.tsx

function DoctorDetailTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: calc(100vh - 60px);\n"
    ]);
    DoctorDetailTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorDetailTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    DoctorDetailTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorDetailTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  z-index: 2;\n\n  ",
        ";\n"
    ]);
    DoctorDetailTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorDetailTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 40px;\n"
    ]);
    DoctorDetailTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorDetailTemplate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    DoctorDetailTemplate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorDetailTemplate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 12px;\n  width: 100%;\n  text-align: center;\n  ",
        ";\n"
    ]);
    DoctorDetailTemplate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






















var DoctorDetailTemplate = function(param) {
    var doctorDetailViewModel = param.doctorDetailViewModel, doctorReviewsViewModel = param.doctorReviewsViewModel, client = param.client;
    var ref = (0,useReviewReportModal/* default */.Z)(), showReportModal = ref.showReportModal, onCloseReportModal = ref.onCloseReportModal, reportItems = ref.reportItems;
    var renderDoctorInfoSections = function() {
        return doctorDetailViewModel.getTabs().map(function(tab) {
            switch(tab.value){
                case useDoctorDetailViewModel/* DoctorDetailTabType.NonBenefitPrice */.DP.NonBenefitPrice:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitPrice_NonBenefitPrice, {
                        doctorDetailViewModel: doctorDetailViewModel
                    }, tab.value);
                case useDoctorDetailViewModel/* DoctorDetailTabType.DoctorProfile */.DP.DoctorProfile:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorIntroduction_DoctorIntroduction, {
                        doctorDetailViewModel: doctorDetailViewModel
                    }, tab.value);
                case useDoctorDetailViewModel/* DoctorDetailTabType.Review */.DP.Review:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorReview_DoctorReview, {
                        isMobile: client.isMobile,
                        doctorReviewsViewModel: doctorReviewsViewModel
                    }, tab.value);
                default:
                    return null;
            }
        });
    };
    if (doctorDetailViewModel.isDoctorDetailLoading || !doctorDetailViewModel.doctorDetail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                        isAbsolute: true,
                        backgroundColor: "transparent"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Content */.Z.Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorDetailSkeleton_DoctorDetailSkeleton, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    isAbsolute: true,
                    backgroundColor: doctorDetailViewModel.isHeaderTransparent ? "transparent" : theme/* default.color.white */.Z.color.white
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDetailTemplate_Wrapper, {
                        children: [
                            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaddingTop, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSummary_DoctorSummary, {
                                    doctorDetailViewModel: doctorDetailViewModel,
                                    doctorReviewsViewModel: doctorReviewsViewModel
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsSection, {
                                stickToTop: !client.isMobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default */.Z, {
                                    value: doctorDetailViewModel.selectedTab,
                                    children: doctorDetailViewModel.getTabs().map(function(tab) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default.Item */.Z.Item, {
                                            label: tab.label,
                                            isActive: tab.value === doctorDetailViewModel.selectedTab,
                                            onClick: function() {
                                                return doctorDetailViewModel.onClickTab(tab);
                                            }
                                        }, tab.key);
                                    })
                                })
                            }),
                            renderDoctorInfoSections(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                                isVisible: showReportModal,
                                selectList: reportItems,
                                onClose: onCloseReportModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: logs_doctor/* DoctorDetailLog.DOCTOR_DETAIL_CLICK_TREATMENT_REQUEST */.d.DOCTOR_DETAIL_CLICK_TREATMENT_REQUEST
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDetailTemplate_Col, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        size: "xl",
                                        disabled: !doctorDetailViewModel.getIsBookingAvailable(),
                                        onClick: client.isWebView ? doctorDetailViewModel.requestTreatmentIfLoggedIn : doctorDetailViewModel.openInstallBottomSheet,
                                        children: doctorDetailViewModel.getTreatmentRequestButtonText()
                                    }),
                                    doctorDetailViewModel.isNonF2FDiagnosis() && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickButtonSubTitle, {
                                        children: "진료가 끝나기 전에는 진료비가 결제되지 않아요"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(F2FGuideBottomSheet_F2FGuideBottomSheet, {
                isOpened: doctorDetailViewModel.isOpenedF2FGuideBottomSheet,
                onClose: doctorDetailViewModel.closeF2FGuideBottomSheet,
                onClickF2FGuideBottomSheet: doctorDetailViewModel.onClickF2FGuideBottomSheet
            }),
            doctorDetailViewModel.showLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
                onClickOverlay: doctorDetailViewModel.closeLoginModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                    isWritePage: false,
                    onClick: doctorDetailViewModel.closeLoginModal,
                    redirectUrl: "",
                    trackInfo: {
                        campaign: "doctor_detail",
                        content: "doctor_detail_family_doctor_add_remove",
                        buttonText: "단골 의사 추가/삭제"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var detail_DoctorDetailTemplate = (DoctorDetailTemplate);
var DoctorDetailTemplate_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-925d82ed-0"
})(DoctorDetailTemplate_templateObject());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-925d82ed-1"
})(DoctorDetailTemplate_templateObject1());
var TabsSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-925d82ed-2"
})(DoctorDetailTemplate_templateObject2(), function(param) {
    var theme = param.theme, stickToTop = param.stickToTop;
    return "\n    top: ".concat(stickToTop ? 0 : theme.size.mobileWebHeader.height, "px;\n    background: ").concat(theme.color.white, ";\n  ");
});
var PaddingTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-925d82ed-3"
})(DoctorDetailTemplate_templateObject3());
var DoctorDetailTemplate_Col = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-925d82ed-4"
})(DoctorDetailTemplate_templateObject4());
var StickButtonSubTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-925d82ed-5"
})(DoctorDetailTemplate_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, ";\n    color: ").concat(theme.color.gray400, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/templates/doctor/detail/useDoctorReviewsViewModel.ts + 5 modules
var useDoctorReviewsViewModel = __webpack_require__(17070);
;// CONCATENATED MODULE: ./src/pages/doctors/[doctorId]/index.tsx
// PageDescription: 의사 상세 페이지





var DoctorDetailPage = function(param) {
    var client = param.client;
    var doctorDetailViewModel = (0,useDoctorDetailViewModel/* default */.ZP)(client);
    var doctorReviewsViewModel = (0,useDoctorReviewsViewModel/* default */.ZP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_DoctorDetailTemplate, {
        client: client,
        doctorDetailViewModel: doctorDetailViewModel,
        doctorReviewsViewModel: doctorReviewsViewModel
    });
};
/* harmony default export */ var _doctorId_ = (DoctorDetailPage);
DoctorDetailPage.Layout = DefaultLayout/* default */.Z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,4329,6562,9950,9535,9004,9591,7757,911,7305,9774,2888,179], function() { return __webpack_exec__(57952); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);